/* 🤖 this file was generated by svg-to-ts */
export const matIconTurnSlightRight: {
  name: 'turn-slight-right';
  data: string;
} = {
  name: 'turn-slight-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12.34 6V4H18v5.66h-2V7.41l-5 5V20H9v-7.58c0-.53.21-1.04.59-1.41l5-5h-2.25z"/></svg>`
};
